import { NavigationActions } from 'react-navigation'
import { RESET } from '../redux/game'
import adminApi from '../services/admin-api'

import { AsyncStorage } from 'react-native'
import api from '../services/api'

const AUTH_STORAGE_KEY = '@ascension:auth:details:1'
// Actions
const LOGIN_START = 'ascension/login/fetching'
const LOGIN_SUCCESS = 'ascension/login/success'
const LOGIN_ERROR = 'ascension/login/error'
export const LOGOUT = 'ascension/logout'
// Reducer
const initialState = {
  isLoading: false,
  isLoggedIn: false,
  error: null,
  requiresLogin: true,
  token: null,
  eventId: null,
  participantId: null,
  environment: null
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case LOGIN_START: {
      return {
        ...state,
        isLoading: true,
        error: null
      }
    }
    case LOGIN_SUCCESS: {
      return {
        ...state,
        isLoggedIn: true,
        isLoading: false,
        error: null,
        token: action.data.token,
        eventId: action.data.eventId,
        participantId: action.data.participantId,
        environment: action.data.environment
      }
    }
    case LOGIN_ERROR: {
      return {
        ...state,
        isLoggedIn: false,
        isLoading: false,
        error: action.data
      }
    }
    case LOGOUT:
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

// Action Creators

export function loginStart () {
  return {
    type: LOGIN_START
  }
}

export function loginSuccess (data) {
  return {
    type: LOGIN_SUCCESS,
    data
  }
}

export function loginError (error) {
  return {
    type: LOGIN_ERROR,
    data: error
  }
}

export function logoutAction () {
  return {
    type: LOGOUT
  }
}

export function login ({ email, password, environment, eventId }) {
  return async (dispatch) => {
    dispatch(loginStart())

    try {
      const { token, id: participantId } = await adminApi.login({ email, password, environment, eventId })
      const itemsToStore = { token, environment, eventId, participantId }
      adminApi.setToken(token)
      api.setToken(token)
      api.setGameId(eventId)
      dispatch(loginSuccess(itemsToStore))
      await AsyncStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(itemsToStore))
    } catch (e) {
      dispatch(loginError(e))
    }
  }
}

export function logout (navigation) {
  return async (dispatch) => {
    adminApi.setToken(null)
    api.setToken(null)
    api.setGameId(null)
    await AsyncStorage.removeItem(AUTH_STORAGE_KEY)
    dispatch(logoutAction())
    if (navigation.navigate) {
      navigation.navigate('Login')
    }
    if (navigation.dispatch) {
      navigation.dispatch(
        NavigationActions.navigate({
          routeName: 'Login',
          params: {}
        })
      )
    }
  }
}

export function fetchAuthToken (navigation, { environment, eventId }) {
  return async (dispatch) => {
    try {
      let persistedAuth = await AsyncStorage.getItem(AUTH_STORAGE_KEY)
      if (persistedAuth) {
        persistedAuth = JSON.parse(persistedAuth)
        if (environment && environment !== persistedAuth.environment) {
          throw new Error('Changing environment')
        }
        adminApi.setToken(persistedAuth.token)
        api.setToken(persistedAuth.token)
        api.setGameId(persistedAuth.eventId)
        dispatch(loginSuccess(persistedAuth))
        navigation.navigate('App')
      } else {
        navigation.navigate('Login')
      }
    } catch (e) {
      console.log(e)
      navigation.navigate('Login')
    }
  }
}
